'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _Table = require('material-ui/Table');

var _Toggle = require('material-ui/Toggle');

var _Toggle2 = _interopRequireDefault(_Toggle);

var _SelectField = require('material-ui/SelectField');

var _SelectField2 = _interopRequireDefault(_SelectField);

var _MenuItem = require('material-ui/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @desc
 * A material-ui [Table](http://www.material-ui.com/#/components/table) with sorting and filtering.
 * ```
 * const columns = [
 *     {key: 'id', fieldName: 'Id', name: 'Id'},
 *     {key: 'title', fieldName: 'Title', name: 'Tittel'},
 * ]
 *
 * const items = [
 *     {Id: 23, Title: 'This one time...'},
 *     {Id: 7, Title: 'Free lunch'},
 * ]
 *
 *
 * <FilterTable
 *     columns={columns}
 *     items={items}
 *     defaultSortBy={1}
 *     onSelect={this.handleSelect}
 * />
 * ```
 */
var FilterTable = function (_React$Component) {
    _inherits(FilterTable, _React$Component);

    function FilterTable() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FilterTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilterTable.__proto__ || Object.getPrototypeOf(FilterTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            selected: undefined,
            items: [],
            columns: _this.props.columns || [],
            filter: '',
            filterKey: _this.props.columns[0].fieldName,
            sortBy: _this.props.defaultSortBy || 0,
            desc: _this.props.defaultDesc || false
        }, _this.filterAndSort = function (items, options) {
            items = items || [];
            var opts = Object.assign({
                filter: _this.state.filter,
                filterKey: _this.state.filterKey,
                sortBy: _this.state.sortBy,
                desc: _this.state.desc
            }, options);

            var columns = _this.state.columns;
            var filter = opts.filter,
                filterKey = opts.filterKey,
                sortBy = opts.sortBy,
                desc = opts.desc;

            var sortKey = columns[sortBy].fieldName;

            var result = items.map(function (item) {
                return _extends({}, item);
            });
            if (filter && filter.length > 2) {
                result = result.filter(function (item) {
                    return item[filterKey].toLowerCase().indexOf(filter.toLowerCase()) !== -1;
                });
            }
            result.sort(function (a, b) {
                var x = typeof a[sortKey] === "string" ? a[sortKey].toLowerCase() : a[sortKey];
                var y = typeof b[sortKey] === "string" ? b[sortKey].toLowerCase() : b[sortKey];
                if (desc) {
                    return x < y ? 1 : -1;
                }
                return x < y ? -1 : 1;
            });
            return result;
        }, _this.selectionCallback = function (item) {
            if (_this.props.onSelect) {
                _this.props.onSelect(item);
            }
        }, _this.handleRowSelection = function (selected) {
            _this.setState({ selected: selected[0] });
            _this.selectionCallback(_this.state.items[selected[0]]);
        }, _this.handleFilterChange = function (e) {
            _this.setState({
                filter: e.target.value,
                selected: null,
                items: _this.filterAndSort(_this.props.items, { filter: e.target.value })
            });
            _this.selectionCallback(undefined);
        }, _this.handleSortByChange = function (e, index, value) {
            _this.setState({
                sortBy: value,
                selected: null,
                items: _this.filterAndSort(_this.props.items, { sortBy: value })
            });
            _this.selectionCallback(undefined);
        }, _this.handleToggleDesc = function (e, checked) {
            _this.setState({
                desc: checked,
                selected: null,
                items: _this.filterAndSort(_this.props.items, { desc: checked })
            });
            _this.selectionCallback(undefined);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * @type {Object}
     * @property {[{key: string, fieldName: string, name: string}]} columns list of columns.
     * @property {Object[]} items list of items. {<fieldName>: <value>}
     * @property {function(selectedItem: Object):} onSelect callback function for selected item.
     * @property {number} defaultSortBy which column index to default sort by. Default: 0.
     * @property {boolean} defaultDesc is descending ordering on by default?
     */


    /**
     * @type {Object}
     */


    _createClass(FilterTable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                items: this.filterAndSort(this.props.items)
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!(0, _deepEqual2.default)(this.props.items, nextProps.items)) {
                this.setState({
                    items: this.filterAndSort(nextProps.items),
                    selected: undefined
                });
            }
        }

        /**
         * @type {function}
         * @param {Object[]} items
         * @param {Object} options
         * @param {string} options.filter
         * @param {string} options.filterKey
         * @param {number} options.sortBy
         * @param {boolean} options.desc
         * @return {Object[]} list of filtered and sorted items.
         */


        /**
         * @type {function}
         */


        /**
         * @type {function}
         */


        /**
         * @type {function}
         */


        /**
         * @type {function}
         */


        /**
         * @type {function}
         */

    }, {
        key: 'render',


        /**
         * @return {Node}
         */
        value: function render() {
            var _props = this.props,
                columns = _props.columns,
                items = _props.items,
                onSelect = _props.onSelect,
                defaultSortBy = _props.defaultSortBy,
                defaultDesc = _props.defaultDesc,
                other = _objectWithoutProperties(_props, ['columns', 'items', 'onSelect', 'defaultSortBy', 'defaultDesc']);

            var state = this.state;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', flexWrap: 'wrap' } },
                    _react2.default.createElement(_TextField2.default, {
                        style: { marginRight: '1em' },
                        floatingLabelText: 'Filtrer p\xE5',
                        hintText: 'Minst 3 tegn',
                        value: state.filter,
                        onChange: this.handleFilterChange
                    }),
                    _react2.default.createElement(
                        _SelectField2.default,
                        {
                            floatingLabelText: 'Sorter p\xE5',
                            value: state.sortBy,
                            onChange: this.handleSortByChange
                        },
                        state.columns.map(function (col, index) {
                            return _react2.default.createElement(_MenuItem2.default, {
                                key: index,
                                value: index,
                                primaryText: col.name
                            });
                        })
                    ),
                    _react2.default.createElement(_Toggle2.default, {
                        style: { display: 'inline-block', width: 'auto', marginTop: 35 },
                        label: 'Reverser sortering',
                        labelStyle: { whiteSpace: 'nowrap' },
                        toggled: state.desc,
                        onToggle: this.handleToggleDesc
                    })
                ),
                _react2.default.createElement(
                    _Table.Table,
                    _extends({
                        fixedHeader: true,
                        selectable: true,
                        multiSelectable: false,
                        onRowSelection: this.handleRowSelection
                    }, other),
                    _react2.default.createElement(
                        _Table.TableHeader,
                        {
                            displaySelectAll: false,
                            adjustForCheckbox: true,
                            enableSelectAll: false
                        },
                        _react2.default.createElement(
                            _Table.TableRow,
                            null,
                            state.columns.map(function (col) {
                                return _react2.default.createElement(
                                    _Table.TableHeaderColumn,
                                    { key: col.key },
                                    col.name
                                );
                            })
                        )
                    ),
                    _react2.default.createElement(
                        _Table.TableBody,
                        {
                            displayRowCheckbox: true,
                            deselectOnClickaway: false
                        },
                        state.items.map(function (prop, index) {
                            return _react2.default.createElement(
                                _Table.TableRow,
                                {
                                    key: index,
                                    selected: state.selected === index
                                },
                                state.columns.map(function (col) {
                                    return _react2.default.createElement(
                                        _Table.TableRowColumn,
                                        { key: col.key },
                                        prop[col.fieldName]
                                    );
                                })
                            );
                        })
                    )
                )
            );
        }
    }]);

    return FilterTable;
}(_react2.default.Component);

FilterTable.propTypes = {
    columns: _propTypes2.default.array.isRequired,
    items: _propTypes2.default.array.isRequired,
    onSelect: _propTypes2.default.func,
    defaultSortBy: _propTypes2.default.number,
    defaultDesc: _propTypes2.default.bool
};
exports.default = FilterTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/material/FilterTable.js
// module id = 680
// module chunks = 0